import axios from 'axios';
import { baseUrl, decodeJwt, UserRole } from '../Pages/ApiCommonService';
import { expTokenProcessAndGenerate } from './AuthApis';


const token = sessionStorage.getItem('token');

// -------------------****Api Calls Outside the UserMasterTables (fetchUser, editUserByrowId, saveData, activateOrDeactivate)****-------------------------//

export const fetchUser = async (pageNo?: any, pageSize?: any, searchTerm?: string) => {        // getApi to fetchUsers in the Usermaster screen
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + `api/master/getAllUsers?pageNo=${pageNo}&pageSize=${pageSize}&searchTerm=${encodeURIComponent(searchTerm ?? '')}&isExport=false`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in fetching the user:', error);
        throw error;
    }
};

export const assignMenusForRole = async () => {
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl +
            "api/master/assignMenusForRole",
            {},
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error assigning menus", error);
        return null;
    }
}

export const saveRoleMenuControl = async (selectedRow: any) => {    // saveApi if any selected RowItem is updated or new User creation in menucontrol
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/master/saveMenuControl", selectedRow, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error creating_Or_updating user:", error);
        throw error;
    }
};

export const generateExportExcelforUsers = async () => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        let url = `${baseUrl}api/master/ExportUsers`;

        const response = await axios.get(url, {
            responseType: 'blob',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading allUsers:', error);
        throw error;
    }
};

export const getUserAlaisById = async (ID: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/user/getUsersAliasById?user_id=${ID}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });

        return response?.data || [];
    } catch (error) {
        console.error('Error in fetching the user:', error);
        return [];
    }
};

export const getUserExists = async (username: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/user/getUserExists?userName=${encodeURIComponent(username)}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });

        return response?.data || [];
    } catch (error) {
        console.error('Error in fetching the user:', error);
        return [];
    }
};

export const getUserAlaisExists = async (username: any) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/user/getUserAlaisExists?userName=${encodeURIComponent(username)}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });

        return response?.data || [];
    } catch (error) {
        console.error('Error in fetching the user:', error);
        return [];
    }
};

export const getbroker = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + 'api/master/getAllBrokers', {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            const activeBroker = response?.data?.filter((e: any) => e?.bitActive);
            return activeBroker;
        }
    } catch (error) {
        console.error('Error in fetching the user:', error);
        throw error;
    }
};

export const editUserByRowSelection = async (ID: string) => {     // getApi to edit the user on click of Edit icon
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.get(baseUrl + `api/master/getUserById?user_id=${ID}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error('Error in editing the selected user:', error);
        throw error;
    }
};

export const saveUser = async (selectedRow: any, editMode: boolean) => {    // saveApi if any selected RowItem is updated or new User creation
    try {
        const isEdit = !!editMode;
        const userID = isEdit ? selectedRow?.ID : 0;
        const UserType = selectedRow?.RoleID - 1;

        const payload = {
            UserMaster: {
                ID: userID,
                FirstName: selectedRow?.vchFname || "",
                LastName: selectedRow?.vchLname || "",
                MiddleName: selectedRow?.vchMname || "",
                Email: selectedRow?.vchEmail || "",
                UserType: UserType?.toString() || 0,
                AuthType: selectedRow?.AuthType || "",
                Mobile: selectedRow?.vchMobile || "",
                RoleID: selectedRow?.RoleID?.toString() || 0,
                BranchCode: "",
                SendEmail: selectedRow?.SendEmail || false,
            },
            UserAliases: (selectedRow?.AliasEmails || [])?.filter((email: any) => email?.trim())?.map((email: string) => ({
                UserID: userID,
                Email: email,
                CreatedOn: new Date().toISOString()
            }))
        };

        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/user/addOrUpdateUser", payload, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
    } catch (error) {
        console.error("Error creating_Or_updating user:", error);
        throw error;
    }
};

export const activateAndDeactivateUsers = async (id: string, status: boolean) => {      // Api to active and deactive the selected user rowItem
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        await axios.post(
            `${baseUrl}api/master/activateOrDeactivateUser?user_id=${id}&status=${status}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );
    } catch (error) {
        console.error("Error updating user status:", error);
        throw error;
    }
};

export const fetchActiveBrokers = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + 'api/master/brokers', {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error('Error fetching active brokers:', error);
        throw error;
    }
};

export const fetchCSRUsersByBroker = async (brokerId: number) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + `api/master/GetCsrUsersByBrokerId?broker_id=${brokerId}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(`Error fetching CSR users for broker ${brokerId}:`, error);
        throw error;
    }
};

export const fetchMenuControls = async () => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const response = await axios.get(baseUrl + `api/master/getAllMenuControl`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.error(`Error fetching Menucontrol:`, error);
        throw error;
    }
};

export const fetchAllUsers = async (searchTerm?: string) => {
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        // Step 1: Get totalCount with a lightweight call
        const initialResponse = await axios.get(
            `${baseUrl}api/master/getAllUsers?pageNo=0&pageSize=1&searchTerm=${encodeURIComponent(searchTerm ?? '')}&isExport=false`,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        const totalCount = initialResponse?.data?.totalCount ?? 0;

        // Step 2: Now fetch all users using totalCount as pageSize
        const fullResponse = await axios.get(
            `${baseUrl}api/master/getAllUsers?pageNo=0&pageSize=${totalCount}&searchTerm=${encodeURIComponent(searchTerm ?? '')}&isExport=false`,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json",
                },
            }
        );

        return fullResponse?.data;
    } catch (error) {
        console.error('Error fetching all users:', error);
        throw error;
    }
};

export const GetMarshalBrokerConfig = async () => {
    let brokerId = 0;
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        const decodedToken = decodeJwt(Token);

        const MisUser = decodedToken.RoleId === UserRole.MSUser;
        const Miuser_brokerid = sessionStorage.getItem('selectedBrokerId');

        brokerId = MisUser ? Number(Miuser_brokerid) : Number(decodedToken?.BrokerId) || 0;

        const response = await axios.get(baseUrl + `api/master/GetMarshalBrokerConfig?broker_id=${brokerId}`, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error(`Error fetching CSR users for broker ${brokerId}:`, error);
        throw error;
    }
};

export const GenerateAMSUrl = async (jobId: string, Email: string) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const URL = `${baseUrl}api/master/GenerateAMSURL?JobId=${jobId}&UserEmail=${encodeURIComponent(Email)}`;
        const response = await axios.get(URL, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error in generating AMS Url:', error);
        throw error;
    }
}

export const GetAutoDispatcherStpMaster = async (pageNo: number, pageSize: number, brokerId: number, templateName: string | undefined, lobCode: string | undefined) => {
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const params = new URLSearchParams({});
        if (pageNo) {
            params.append("pageNo", pageNo.toString());
        }
        if (pageSize) {
            params.append("pageSize", pageSize.toString());
        }
        if (brokerId) {
            params.append("brokerId", brokerId.toString());
        }
        if (templateName) {
            params.append("templateName", templateName.toString());
        }
        if (lobCode) {
            params.append("lobCode", lobCode.toString());
        }

        const URL = `${baseUrl}api/master/GetAutoDispatcherStpMaster?${params.toString()}`;
        const response = await axios.get(URL, {
            headers: { "Authorization": `Bearer ${Token}`, "Content-Type": "application/json" },
        });
        if (response.status === 200) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error in generating AMS Url:', error);
        throw error;
    }
}

interface UpdateAutoDispatcherStpMasterInterface {
    id: number;
    carrierName: string;
}

export const UpdateAutoDispatcherStpMaster = async (body: UpdateAutoDispatcherStpMasterInterface) => {
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.put(baseUrl +
            "api/master/UpdateAutoDispatcherStpMaster",
            body,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response;
    } catch (error) {
        console.error("Error assigning menus", error);
        return null;
    }
}

interface AddAutoDispachStpInterface {
    brokerId: number;
    templateName: string;
    includeEndorsement: boolean;
    arEnabled: boolean;
    ssdEnabled: boolean;
    msdEnabled: boolean;
    metaData: string;
    lobCode: string;
    carrierName: string;
    ignoreStp: boolean;
}

export const AddAutoDispatcherStpMaster = async (body: AddAutoDispachStpInterface) => {
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl +
            "api/master/AddAutoDispatcherStpMaster",
            body,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response;
    } catch (error) {
        console.error("Error assigning menus", error);
        return null;
    }
}

export const ActivateorDeactivateAdStpMaster = async (id: number, status: boolean) => {
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const params = new URLSearchParams({});
        if (id) {
            params.append("id", id.toString());
        }
        params.append('status', status.toString());
        const response = await axios.put(baseUrl +
            "api/master/ActivateorDeactivateAdStpMaster?" + params.toString(),
            null,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response;
    } catch (error) {
        console.error("Error assigning menus", error);
        return null;
    }
}

export const MasterDeleteAdStpMaster = async (id: number) => {
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const params = new URLSearchParams({});
        if (id) {
            params.append("id", id.toString());
        }
        const response = await axios.delete(baseUrl +
            "api/masterDeleteAdStpMaster?" + params.toString(),
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response;
    } catch (error) {
        console.error("Error assigning menus", error);
        return null;
    }
}

export const UpdateIgnoreStp = async (id: number, status: boolean) => {
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const params = new URLSearchParams({});
        if (id) {
            params.append("id", id.toString());
        }
        params.append("status", status.toString());
        const response = await axios.put(baseUrl +
            "api/master/UpdateIgnoreStp?" + params.toString(), null,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response;
    } catch (error) {
        console.error("Error assigning menus", error);
        return null;
    }
}

export const getAllUserAccess = async () => {   //Api call for exportExcel
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);

        let url = `${baseUrl}api/user/getAllUserAccess`;

        const response = await axios.get(url, {
            responseType: 'json',
            headers: {
                "Authorization": `Bearer ${Token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error in downloading allUsers:', error);
        throw error;
    }
};

export const AddorUpdateUserAccess = async (selectedRow: any) => {    // saveApi if any selected RowItem is updated or new User creation in menucontrol
    try {
        const Token = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const response = await axios.post(baseUrl + "api/user/AddorUpdateUserAccess", selectedRow, {
            headers: {
                "Authorization": `Bearer ${Token}`,
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
        return response;
    } catch (error) {
        console.error("Error creating_Or_updating user:", error);
        throw error;
    }
};

export const UpdateUserAccessStatus = async (id: number, status: boolean) => {
    try {
        const Token: any = await expTokenProcessAndGenerate(sessionStorage.getItem('token') || token);
        const params = new URLSearchParams({});
        if (id) {
            params.append("Id", id.toString());
        }
        params.append('status', status.toString());
        const response = await axios.put(baseUrl +
            "api/user/UpdateUserAccessStatus?" + params.toString(),
            null,
            {
                headers: {
                    "Authorization": `Bearer ${Token}`,
                    "Content-Type": "application/json"
                }
            }
        );
        return response;
    } catch (error) {
        console.error("Error assigning menus", error);
        return null;
    }
}

// ------------------------------------------------------------------------------------------------------------------------------------------------------//
